<template>
  <div class="base-box">
    <v-head :title="title"></v-head>
    <div style="text-align:center; padding:30px 0;position: fixed;top: 1.5rem;z-index: 999;">
      <van-overlay :show="loading" :lock-scroll="true" style="z-index: 888;">
        <van-loading color="#fff" size="24px" vertical style="z-index: 999;margin-top: 50%;">正在提交中...</van-loading>
      </van-overlay>
    </div>
    <div class="contentOffLine">
      <div>请选择变更类型</div>
      <van-radio-group v-model="upGradeMemberType" direction="horizontal" @change="getFields"
        :disabled="upGradeId?true:false">
        <van-radio v-if=" userInfo.memberType!=1" :name="1">普通会员</van-radio>
        <van-radio v-if="userInfo.memberType!=2" :name="2">高级会员</van-radio>
        <van-radio v-if="userInfo.memberType!=3" :name="3">学生会员</van-radio>
      </van-radio-group>
    </div>
    <div class="fontBox">
      <span>完善信息</span>
      <div v-if="!upGradeMemberType">
        <img src="../../assets/images/empty-image-default.png" />
        <p>请选择变更类型</p>
      </div>
      <advanced-form v-else ref="advForm" :initFields="fields" :formData.sync="member" :allDictionary="allDictionary"
        :allAddress="cityList" :branchsList="branchsList" :customDataList="customDataList"
        @getFields="getFields"></advanced-form>
    </div>
    <div v-if="upGradeMemberType" class="buttonBox">
      <van-button type="primary" size="large" @click="save()">提交</van-button>
    </div>
  </div>
</template>
<script>
  import memberPostTable from "../../components/memberPostTable";
  import researchProjects from "../../views/register/grmember/researchProjects.vue";
  import AdvancedForm from "../../components/AdvancedForm.vue";
  import vHead from "../../components/Subhead.vue";
  import {
    findFileById,
    getBranchs,
    getSingleRegisterSetting,
    saveMembers,
    upGradeSingleApply
  } from "@/api/dictionary";
  import {
    // upGradeSingleApply,
  } from "@/api/login";
  import {
    Field,
    NavBar,
    Button,
    Toast,
    Tab,
    Tabs,
    Dialog,
    Overlay, Loading,
    RadioGroup, Radio
  } from "vant";
  import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

  export default {
    data() {
      return {
        loading: false,
        active: 0,
        title: "变更会员类型",
        show: false,
        allAddress: [],
        items: [],
        addrItems: [],
        titleId: null,
        cityId: null,
        activeId: null,
        activeIndex: null,
        infos: {},
        changeData: {},
        params: {
          memberType: null,
          name: "",
          code: "",
          gender: null,
          birthday: new Date(),
          partisan: "",
          workNature: "",
          title: "",
          education: "",
          degree: "",
          idType: "",
          nationality: "",
          recommendUnitId: "",
          concernUnitId: "",
          nativeProvince: "",
          nativeCity: "",
          province: "",
          city: "",
          titleFileId: "",
          portraitId: "",
          school: "",
          major: "",
          company: "",
          socialTenure: "",
          idNumber: "",
          workMajor: "",
          jobPerformance: "",
          fullAddress: "",
          zipcode: "",
          email: "",
          mobile: "",
          telephone: "",
          experience: "",
          achievement: "",
          awards: "",
        },
        branchList: [],
        customDataList: {},
        member: {},
        fields: [],
        upGradeMemberType: ''
      };
    },
    components: {
      vHead,
      memberPostTable,
      AdvancedForm,
      researchProjects,
      [Field.name]: Field,
      [Button.name]: Button,
      [Toast.name]: Toast,
      [NavBar.name]: NavBar,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Dialog.name]: Dialog,
      [Loading.name]: Loading,
      [Overlay.name]: Overlay,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
    },
    computed: {
      ...mapState([
        "memberTypeList",
        "zhichengList",
        "cityList",
        "titleList",
        "addrList",
        "branchsList",
        "userInfo"
      ]),
      ...mapGetters([
        "allDictionary",
        "GENDER",
        "POLITICAL_STATUS",
        "EDUCATION",
        "DEGREE",
        "WORK_NATURE",
        "ID_TYPE",
        "NATIONALITY",
      ]),
      titleFileId() {
        return this.$route.query && this.$route.query.titleFileId;
      },
      upGradeId() {
        return this.$route.query && this.$route.query.upGradeId;
      },

      //会员类型名称
      memberName() {
        let id = this.params.memberType;

        if (!id) {
          return "内容";
        } else {
          let obj = this.memberTypeList.find((item) => item.memberType === id);
          return obj.dueName;
        }
      },
      gender() {
        let id = this.params.gender;
        if (!id && id !== 0) {
          return "内容";
        } else {
          let obj = this.GENDER.find((item) => item.value === id);
          if (obj) return obj.name;
        }
      },
      sheng() {
        return this.cityList.filter((item) => {
          return item.level === 1;
        });
      },
      shi: function () {
        return this.cityList.filter((item) => {
          return item.parentId === this.sheng[0].id;
        });
      },
      portraitId() {
        return this.$route.query && this.$route.query.portraitId;
      },
      titleName() {
        return this.$route.query && this.$route.query.titleName;
      },
      portraitName() {
        return this.$route.query && this.$route.query.portraitName;
      },
    },
    methods: {
      ...mapActions([
        "getDictionaryList",
        "getMemberTypeList",
        "getBranchsList",
        "getZhiChengList",
        "getCityList",
      ]),
      ...mapMutations(["setMemberInfo"]),
      change() { },
      onClickLeft() {
        if (!this.member.memberNo && !this.member.memberStatus) {
          Dialog.alert({
            title: '提示',
            message: '请您填写并提交入会申请表！',
          }).then(() => {
            // on close
          });
          return;
        }
        this.$router.push({ name: "MemberCenter" });
      },
      save() {
        let params = this.member;
        let valid = this.$refs["advForm"].validateForm();
        if (!valid) {
          return;
        }
        if (params.birthday) {
          params.birthday = params.birthday.substr(0, 10);
        }
        if (params.expiryDate && params.expiryDate.length == 10) {
          params.expiryDate = params.expiryDate + ' ' + '00' + ":" + '00' + ":" + '00';
        }
        params.upGradeId = this.upGradeId
        params.upGradeMemberType = this.upGradeMemberType
        this.loading = true
        upGradeSingleApply(params).then((res) => {
          if (res.success) {
            this.loading = false
            this.$router.push({ name: "changeApplyList" });
          } else {
            this.loading = false
            Toast.fail("保存失败");
          }
        });
      },

      getFields(val) {
        console.log('val', val)
        var params = {};
        if (val) {
          this.member.memberType = +val
          if (val == 1) {//普通会员1
            params.batchType = 5;
            params.businessType = 2;
          } else if (val == 2) {//高级会员2
            params.batchType = 5;
            params.businessType = 16;
          } else if (val == 3) {//学生会员3
            params.batchType = 5;
            params.businessType = 15;
          } else {//会议注册网员9
            params.batchType = 5;
            params.businessType = 2;
          }
        } else {
          if (this.member.memberType == 1) {//普通会员1
            params.batchType = 5;
            params.businessType = 2;
          } else if (this.member.memberType == 2) {//高级会员2
            params.batchType = 5;
            params.businessType = 16;
          } else if (this.member.memberType == 3) {//学生会员3
            params.batchType = 5;
            params.businessType = 15;
          } else {//会议注册网员9
            params.batchType = 5;
            params.businessType = 2;
          }
        }
        getSingleRegisterSetting(params).then((resp) => {
          if (resp.success) {
            this.fields = resp.result;
          } else {
            this.$message.error(resp.message);
          }
        });
      },
    },

    mounted() {
      var obj = window.localStorage.getItem("userInfo");
      this.member = JSON.parse(obj);
      if (this.member.expiryDate) {
        this.member.expiryDate = this.member.expiryDate.substr(0, 10);
      }
      getBranchs().then((res) => {
        if (res.success) {
          res.result.forEach((itm) => (itm.value = itm.code));
          this.customDataList["recommendUnitId"] = res.result;
          this.customDataList["concernUnitId"] = res.result;
          this.branchList = res.result;
        }
      });
      this.getDictionaryList();
      this.getMemberTypeList();
      this.getZhiChengList();
      //this.getBranchsList();
      this.getCityList();
    },
    beforeRouteEnter(to, from, next) {
      if (!to.params.id) {
        next({ name: 'changeApplyList' });
      } else {
        next(vm => {
          vm.member = to.params;
          if (to.query.upGradeMemberType) {
            vm.member.memberType = +to.query.upGradeMemberType;
            vm.member.upGradeMemberType = +to.query.upGradeMemberType;
            vm.upGradeMemberType = to.query.upGradeMemberType;
          }
          if (vm.$refs["advForm"]) {
            vm.$refs["advForm"].onFormDataChanged(vm.member);
          }
        });
      }

    }
  };
</script>

<style lang="less" scoped>
  .contentOffLine {
    font-size: 15px;
    width: 100%;
    background-color: #fff;
    height: 60px;
    padding: 10px;
    margin: 10px auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: black;
  }

  .buttonBox {
    background: #f3f6fb;
    padding: 20px 10px;
    display: flex;


    button {
      margin: 0 10px
    }
  }

  .base-item {
    margin-top: 10px;
  }

  .nextBtn {
    margin-top: 35px;
    height: 45px !important;
    line-height: 45px;
  }

  .base-box {
    background: #efefef;
  }

  .base-box>p {
    font-size: 13px;
    color: #999;
    margin: 20px 0 8px 0;
    margin-left: 20px;
  }

  .fontBox {
    font-size: 14px;
    padding: 18px 18px 0;
    //   border-top: #f3f6fb solid 10px;
    color: #323233;
    background: #fff;
  }



  .fontBox img {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }

  .fontBox p {
    text-align: center;
    margin-bottom: 15px
  }

  .fontBox thead {
    background: #f2f2f2;
  }

  .fontBox table td {
    font-size: 15px;
    margin: 0;
    color: #000;
    padding: 10px 0;
  }

  table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    border-spacing: 1;
    border-spacing: 0;
  }

  table td {
    word-break: break-all;
    word-wrap: break-word;
    border: 1px solid #dfdfdf;
  }
</style>